import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, Eyebrow } from "@/components/Reveal";

const KEYS = ["a", "b", "c", "d"];

const Faq = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section className="relative py-16 md:py-32 px-6 md:px-12 bg-card">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <div className="mb-14">
            <Eyebrow>{t("faq.badge")}</Eyebrow>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl text-foreground leading-tight">
              {t("faq.title")}
            </h2>
          </div>
        </Reveal>

        <div className="divide-y divide-border border-t border-border">
          {KEYS.map((key, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={key} delay={i * 0.06}>
                <div>
                  <button
                    data-testid={`faq-q-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 py-6 text-left group"
                  >
                    <span className="font-serif text-xl md:text-2xl text-foreground group-hover:text-gold transition-colors">
                      {t(`faq.items.${key}.q`)}
                    </span>
                    <Plus
                      size={22}
                      className={`shrink-0 text-gold transition-transform duration-300 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        data-testid={`faq-a-${i}`}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 text-muted-foreground font-sans leading-relaxed max-w-2xl">
                          {t(`faq.items.${key}.a`)}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
